import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { observer } from 'mobx-react';
import moment from 'moment';
import SocialMedia from "../../components/socialMedia";
import pages from '../../subscriber/Pages';
import {
    getArray,
    getArrayLength,
    isObjectTruthy,
    isTruthy,
    safeReplace
} from '../../utils/helpers';
import { getBlog } from '../../provider/Blogs';
import BlogComments from '../../components/BlogComments';
import BlogCommentsForm from '../../components/BlogCommentsForm';
import Pagination from '../../components/pagination';
import staticBlogs from '../../data/blogs.json';
import SeoHelmet from '../../components/SeoHelmet';
import { languageStore } from '../../subscriber/Language';
import Layout from "../layout";

// Mock data object (replace this with API call in the future)
const BlogDetail = () =>  {
    const [blogSlug, setBlogSlug] = useState(null);
    const [ blog, setBlog ] = useState({});
    const [prevBlog, setPrevBlog] = useState(null);
    const [nextBlog, setNextBlog] = useState(null);
    const { blogs } = pages
    const { getPageTranslations } = languageStore;
    const {detail: t} = getPageTranslations('blog');
    const { slug } = useParams();

    useEffect(() => {
        setBlogSlug(slug);
    }, [slug]);

    useEffect(() => {
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
    }, [blogSlug]);

    useEffect(() => {
        const fetchblog = async () => {
            if (blogSlug) {
                const blogList = getArray(blogs);
                const currentIndex = blogList.findIndex(item => item.slug === blogSlug);

                if (currentIndex === -1) {
                    const response = await getBlog(blogSlug)
                    if(isObjectTruthy(response)) {
                        setBlog(response);
                    } else {
                        setBlog({});
                    }
                } else {
                    setBlog(blogList[currentIndex]);
                    const prevBlog = currentIndex > 0 ? blogList[currentIndex - 1] : null;
                    const nextBlog = currentIndex < blogList.length - 1 ? blogList[currentIndex + 1] : null;
                    setPrevBlog(prevBlog);
                    setNextBlog(nextBlog);
                }
            }
        };
        
        fetchblog();
    }, [blogSlug, blogs]);
    // 👇 SEO meta only from staticBlogs
    const seoBlog = staticBlogs.find(b => b.slug === slug);

    const updateSlug = (newSlug) => {
        setBlogSlug(newSlug)
    }
    
    return (
        <Layout>
            <SeoHelmet
                title={seoBlog?.name}
                description={seoBlog?.sort_description}
                image={seoBlog?.path}
                url={seoBlog?.url}
            />
            {isObjectTruthy(blog) && (
                <div className="bg-[#FFF] min-h-screen">
                    {/* Hero Section */}
                    <section className="relative h-[60vh] md:h-[80vh] lg:h-[50vh] bg-cover bg-center" style={{backgroundImage: `url(${blog.path})`}}>
                        <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                        <div className="container mx-auto px-4 h-full flex flex-col justify-center items-center relative z-10">
                            <span className="bg-secondary text-white px-3 py-2 mb-4">{blog.category.name}</span>
                            <h1 className="text-4xl font-['__Libre_Caslon_Display_7cf3ab'] md:text-5xl text-white font-bold text-center mb-4">{blog.name}</h1>
                            <div className="flex items-center text-white">
                                <span>{t.by} {blog.author}</span>
                                <span className="mx-2">•</span>
                                <span>{moment(blog.published_at).format("MMM DD, YYYY")}</span>
                            </div>
                        </div>
                    </section>

                    {/* Main Content */}
                    <main className="container mx-auto px-4 py-16">
                        <div className="flex flex-wrap -mx-4">
                            {/* Sidebar */}
                            <SocialMedia />

                            {/* Main Content */}
                            <div className="w-full md:w-8/12 px-4">
                                <article className="prose max-w-none">
                                    <div
                                        dangerouslySetInnerHTML={{
                                        __html: safeReplace(blog.description, '../../asserts', '/asserts')
                                        }}
                                    />
                                </article>
                                {
                                    getArrayLength(blog.tags) > 0 &&
                                        <div className="mt-8 pt-8 border-t border-gray-200">
                                            <span className="font-semibold">{t?.tags}: </span>
                                            <span>{getArray(blog.tags).map(tag => tag.name).join(', ')}</span>
                                        </div>
                                }

                                {/* Comments Section */}
                                {isTruthy(blog.enable_comments) && (
                                    <div className="mt-16 pt-8 border-t border-gray-200">
                                        <h2 className="text-3xl font-bold mb-8">{t?.comments}</h2>
                                        {/* Add your comment form and list here */}
                                        <BlogComments slug={blogSlug} t={t} />
                                        <BlogCommentsForm blog={blog} t={t} />
                                    </div>
                                )}
                            </div>
                        </div>
                    </main>
                    {/* <SocialSection t={social}/> */}
                    <Pagination
                        prevLink={prevBlog ? `${prevBlog.slug}` : ''}
                        prevTitle={prevBlog?.name}
                        nextLink={nextBlog ? `${nextBlog.slug}` : ''}
                        nextTitle={nextBlog?.name}
                        onNavigate={updateSlug}
                    />
                </div>
            )}
        </Layout>
    );
}

export default observer(BlogDetail);